document.addEventListener("DOMContentLoaded", () => {
  const popupsOpenBtns = document.querySelectorAll(
    ".boa-content-buttons .btn--arrow"
  );
  popupsOpenBtns.forEach((button) =>
    button.addEventListener("click", toggleMushroomPopup)
  );
});
function toggleMushroomPopup(e) {
  const targetEl = e.target;
  targetEl.querySelector(".btn--arrow-span")?.classList?.toggle("closed-arrow"); // changes arrow icon with close icon
  targetEl.closest(".column__btn")?.classList?.toggle("full-border"); // set border to the button
  const parentWrapEl = targetEl.closest(".column__content");
  parentWrapEl
    .querySelector(".boa-content-text")
    ?.classList?.toggle("blured-text"); // blurs the text
  parentWrapEl
    .querySelector(".boa-icons-list-wrap")
    ?.classList?.toggle("opened"); // opens popup
}
